import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { TextField, MenuItem, Select, FormControl, InputLabel, Box } from "@mui/material";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Spinner } from "react-bootstrap";
import { FaUndoAlt } from "react-icons/fa";
import { toast } from "react-toastify";
import { employeeAssetTrasferActionApi } from "../../services/AssetService";
import { SearchUserAreasApi } from "../../services/SearchService";

const EmployeeAssetTransferAction = ({
  actionType,
  open,
  onClose,
  afterSubmit,
  assetData = {},
}) => {
  const [remark, setRemark] = useState("");
  const [loading, setLoading] = useState(false);
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");
  const [areasLoading, setAreasLoading] = useState(false);
  const isAccept = actionType === "accept";

  useEffect(() => {
    if (open) {
      setRemark("");
      setSelectedArea("");
      if (isAccept) {
        fetchUserAreas();
      }
    }
  }, [open, isAccept]);

  const fetchUserAreas = () => {
    setAreasLoading(true);
    SearchUserAreasApi({ user_id: assetData?.to_employee?.id })
      .then((res) => {
        setAreas(res.data.areas || []);
        if (res.data.areas?.length === 1) {
          setSelectedArea(res.data.areas[0].id);
        }
      })
      .catch((err) => {
        toast.error("Failed to load areas");
        console.error(err);
      })
      .finally(() => {
        setAreasLoading(false);
      });
  };

  const handleSubmit = () => {
    setLoading(true);
    const payload = {
      remarks: remark,
      action: isAccept ? "ACCEPTED" : "REJECTED",
      ...(selectedArea && { area_id: selectedArea })  // area_id sent only if selected
    };

    employeeAssetTrasferActionApi(assetData?.id || '', payload)
      .then((res) => {
        toast.success(isAccept ? "Transfer Accepted" : "Transfer Rejected");
        afterSubmit();
        onClose();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          "An error occurred"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const { name, brand } = assetData?.asset || {};
  const employeeName = assetData?.from_employee?.name || "Unknown";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          color: isAccept ? "success.main" : "error.main"
        }}
      >
        <FaUndoAlt />
        {isAccept ? "Accept Transfer Request" : "Reject Transfer Request"}
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          {isAccept
            ? `Accept this asset from ${employeeName}`
            : `Reject this asset from ${employeeName}`}
        </Typography>

        
          <div className="border rounded p-3 bg-light mb-2">
          <Typography variant="body2" className="mb-1">
            <strong>Asset Name:</strong> {name || "-"}
          </Typography>
          <Typography variant="body2">
            <strong>Brand:</strong> {brand || "-"}
          </Typography>
        </div>
    

        

        <TextField
          fullWidth
          label="Remarks"
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
          multiline
          rows={3}
          sx={{ mt: 1 }}
        />
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color={isAccept ? "success" : "error"}
          disabled={loading}
          startIcon={loading && <Spinner size="sm" animation="border" />}
        >
          {isAccept ? "Accept" : "Reject"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmployeeAssetTransferAction;
